import { KeyboardEvent } from 'react';
import { SearchSectionForm } from 'src/components/common/form/search/SearchSectionForm';
import { SearchCodeModalForm } from 'src/components/common/form/search/SearchCodeModalForm';
import { SearchDropDownForm } from 'src/components/common/form/search/SearchDropDownForm';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import useUiuxStore from 'src/store/useUiuxStore';
import { useInfoFormEvents } from 'src/hooks/useInfoFormEvents';
import { InfoCodeSearchFieldConfig } from 'src/types/info-form';
import { searchCustomer } from 'src/apis/customerApi';
import {
	defaultMST2020_R01Filter,
	useMST2020_R01Store,
} from './Store_MST2020_R01';

interface Props {
	onEnterKeyDown: (
		e: KeyboardEvent<HTMLInputElement>,
	) => void;
}

export const SearchSection_MST2020_R01 = ({
	onEnterKeyDown,
}: Props) => {
	const {
		MST2020_R01Filter,
		setMST2020_R01Filter,
	} = useMST2020_R01Store();

	const { setCodeSearchModalProps } = useUiuxStore();
	const { areaCdList } = useCommonCodeStore();

	const custFocusId =
		'infoCustInput_MST2020_R01_search';

	const infoFieldConfigs: InfoCodeSearchFieldConfig[] = [
		{
			fieldName: 'customCd',
			category: '거래처',
			focusId: custFocusId,
			responseMapping: {
				customCd: 'customCd',
				customNm: 'customNm',
			},
			searchFunction: async (
				searchText: string,
			) => {
				const res = await searchCustomer(searchText);

				return res.data.data.find(
					(v) => v.customCd === searchText,
				);
			},
			extraFilter: () => ({
				customCd:
					MST2020_R01Filter.customCd || '',
				customNm:
					MST2020_R01Filter.customNm || '',
			}),
		},
	];

	const { getFieldHandlers } = useInfoFormEvents({
		editData: MST2020_R01Filter,
		setEditData: setMST2020_R01Filter,
		defaultData: defaultMST2020_R01Filter,
		infoFieldConfigs,
		setCodeSearchModalProps,
		formName: 'MST2020_R01_search',
	});

	return (
		<SearchSectionForm>
			<SearchDropDownForm
				label="영업지역"
				value={MST2020_R01Filter.areaCd}
				optionList={areaCdList}
				onChangeItem={(item) =>
					setMST2020_R01Filter({
						areaCd: item?.minorCd || '',
					})
				}
			/>
			<SearchCodeModalForm
				label="거래처"
				value={MST2020_R01Filter.customCd}
				valueLabel={MST2020_R01Filter.customNm}
				handleFoucsId={custFocusId}
				onChange={
					getFieldHandlers('customCd').onChange
				}
				onDoubleClick={
					getFieldHandlers('customCd').onDoubleClick
				}
				onKeyDown={(e) => {
					getFieldHandlers(
						'customCd',
					).onEnterKeyDown(e);

					if (e.key === 'Enter') {
						onEnterKeyDown(e);
					}
				}}
			/>
		</SearchSectionForm>
	);
};
